import type { SampleListStatId } from '../components/samples/SampleListStatsCards';

/** Reports 在庫表の残数量表示モード（API stockFilter と同一） */
export type ReportStockFilter = 'positive' | 'zero' | 'all';

export function stockFilterFromStat(id: SampleListStatId): ReportStockFilter {
  if (id === 'outOfStock') return 'zero';
  if (id === 'total') return 'all';
  return 'positive';
}

export function statFromStockFilter(filter: ReportStockFilter): SampleListStatId {
  if (filter === 'zero') return 'outOfStock';
  if (filter === 'all') return 'total';
  return 'available';
}
